import { useContext } from 'react';
import styled from 'styled-components';
import { media } from 'src/styles/designs';
import { useTranslate } from 'react-t7e';
import { FormatDate, FormatHour } from 'src/components/common/FormatDate';
import { EventPageContext } from 'src/modules/events/components/EventPage/EventPageContext';
import { useIsMultidayEvent } from 'src/modules/events/hooks/useIsMultidayEvent';

const Container = styled.div`
  ${media.w.lessThan.desktop} {
    display: flex;
    gap: 8px;
    align-items: flex-end;
  }
`;

const DateText = styled.div`
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0.08em;
  ${media.w.lessThan.desktop} {
    font-size: 21px;
    line-height: 21px;
  }
`;

const Time = styled.div`
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.08em;
  ${media.w.lessThan.desktop} {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const EventPageHeaderContentDate = () => {
  const { _ } = useTranslate();

  const { event, isNow } = useContext(EventPageContext);

  const { isMultiDayEvent, displayStartDateMonth } = useIsMultidayEvent(event);

  return (
    <Container>
      <DateText>
        {isMultiDayEvent ? (
          <>
            <FormatDate format={displayStartDateMonth ? 'dd.LL' : 'dd'}>
              {event.startDate}
            </FormatDate>
            -<FormatDate format="dd.LL">{event.endDate}</FormatDate>
          </>
        ) : (
          <FormatDate format="dd.LL">{event.startDate}</FormatDate>
        )}
      </DateText>
      <Time>
        {isMultiDayEvent ? (
          <>
            {isNow ? (
              <>
                {_('Ends on')}{' '}
                <FormatDate format="dd.LL">{event.endDate}</FormatDate>{' '}
                <FormatHour>{event.endDate}</FormatHour>
              </>
            ) : (
              <>
                {_('Starts at')} <FormatHour>{event.startDate}</FormatHour>
              </>
            )}
          </>
        ) : (
          <>
            <FormatHour>{event.startDate}</FormatHour>-
            <FormatHour>{event.endDate}</FormatHour>
          </>
        )}
      </Time>
    </Container>
  );
};
